export default {"src":"/_next/static/media/video-gray-icon.1b2d47de.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};